import React from "react";
import CustomCountryCodeSelect from "./CustomCountryCodeSelect";
import { BootstrapInput } from "../../../posnavbar/components/addCustomer/components/bootStrapInput";
import "./NewCountryCodeInput.css";
import { colorConstant } from "../../../../../styles/colorConstant/colorConstant";

const NewCountryCodeInput = ({
  countryOptions,
  customerMobileNumber,
  setCustomerMobileNumber,
  handleKeyPress,
  selectedCountry,
  handleCountryChange,
}) => {
  const isIndia = selectedCountry?.value === "+91";
  const maxDigits = isIndia ? 10 : 15;
  const minDigits = isIndia ? 10 : 4;

  const handleNumberInput = (e) => {
    const number = e.target.value.replace(/\D/g, "");
    if (number.length > maxDigits) {
      return;
    }
    setCustomerMobileNumber(number);
  };

  return (
    <div className="new-country-code-input">
      <CustomCountryCodeSelect
        value={selectedCountry}
        onChange={handleCountryChange}
        options={countryOptions}
      />
      <BootstrapInput
        sx={{
          "& .MuiInputBase-input": {
            backgroundColor: "#ffffff",
            border: "1px solid #e2e8f0",
            borderRadius: "20px",
            boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05) !important",
            fontSize: "0.875rem !important",
            fontWeight: "500 !important",
            color: "#333333 !important",
            padding: "12px 16px",
            height: "48px !important",
            boxSizing: "border-box !important",
            "&::placeholder": {
              color: "#65758B !important",
              opacity: 1,
              fontSize: "0.875rem !important",
              fontWeight: "400 !important",
            },
          },
        }}
        placeholder="Enter Mobile Number"
        id="bootstrap-input"
        autoFocus
        type="tel"
        minLength={minDigits}
        maxLength={maxDigits}
        className="phone-input-new"
        value={customerMobileNumber}
        onChange={handleNumberInput}
        onKeyDown={handleKeyPress}
      />
    </div>
  );
};

export default NewCountryCodeInput;
